import PlacesAutocompleteLib, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { TextField, CircularProgress } from "@mui/material";
import { useRef } from "react";

export const PlacesAutocomplete = ({
  value,
  onChange,
  setValue,
  handleLatAndLngSelect,
  handleMileage,
}) => {
  const suggestionsRef = useRef([]);

  const handleSelect = async (address) => {
    onChange(address);
    const results = await geocodeByAddress(address);
    const { lat, lng } = await getLatLng(results[0]);
    handleLatAndLngSelect(lat, lng);
  };

  const handleBlur = async () => {
    const matchFound = suggestionsRef.current.some(
      (s) => s.description === value
    );

    if (!matchFound && suggestionsRef.current.length > 0) {
      const first = suggestionsRef.current[0];
      onChange(first.description);
      const results = await geocodeByAddress(first.description);
      const { lat, lng } = await getLatLng(results[0]);
      handleLatAndLngSelect(lat, lng);

      handleMileage();
    }
  };

  return (
    <PlacesAutocompleteLib
      value={value}
      onChange={onChange}
      onSelect={handleSelect}
      debounce={300}
      searchOptions={{
        types: ["address"],
        componentRestrictions: { country: ["us", "mx"] },
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
        const filteredSuggestions = suggestions.filter((s) =>
          s.types?.some((t) =>
            [
              "street_address",
              "premise",
              "subpremise",
              "establishment",
            ].includes(t)
          )
        );

        suggestionsRef.current = filteredSuggestions;

        return (
          <div>
            <TextField
              {...getInputProps({
                placeholder: "Enter address",
                onBlur: handleBlur,
              })}
              fullWidth
              size="small"
            />
            {loading && <CircularProgress size={20} />}
            <div style={{ background: "var(--fx-surface-base, #FFFFFF)" }}>
              {filteredSuggestions.map((suggestion) => {
                const style = {
                  padding: 3,
                  backgroundColor: suggestion.active ? "var(--fx-surface-sunken, #F8FAFC)" : "var(--fx-surface-base, #FFFFFF)",
                  cursor: "pointer",
                };
                return (
                  <div
                    key={suggestion.placeId}
                    {...getSuggestionItemProps(suggestion, { style })}
                  >
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        );
      }}
    </PlacesAutocompleteLib>
  );
};
